﻿// project import
import dashboard from './spectra';
import analytics from './analytics';
import support from './support';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [dashboard, analytics/*, support*/]
};

export default menuItems;

